import { sellHttpApi, accountHttpApi } from 'api';
import { clearAuthToken, onAuthChange, propagateAuthToken } from 'shared/utils/auth'

export * from 'shared/utils/auth'

function handleUnauthorized (response: Response) {
  if (response.status === 401) {
    clearAuthToken()
    propagateAuthToken()
  }
}

sellHttpApi.onResponse(handleUnauthorized);
accountHttpApi.onResponse(handleUnauthorized);

onAuthChange((isAuthenticated, { token }) => {
  sellHttpApi.setBearerToken(isAuthenticated ? token : undefined);
  accountHttpApi.setBearerToken(isAuthenticated ? token : undefined);
});
